module.exports = __webpack_public_path__ + "images/internal/review_widgets/embeddable/types/carousel.svg";